import { render, staticRenderFns } from "./AdapterAction.vue?vue&type=template&id=1562b4e8"
import script from "./AdapterAction.vue?vue&type=script&lang=js"
export * from "./AdapterAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports